// The words you have removed from the drill, and the way back.
//
// Removal is global and permanent-feeling, so it needs to be visible and
// undoable from the same screen. Collapsed by default: on a normal run you do
// not want to look at it.

import { useState } from "react";

export default function RetiredWords({ words, onRestore }) {
  const [open, setOpen] = useState(false);

  if (!words.length) return null;

  return (
    <div className="mt-10 border-t border-slate-800 pt-6">
      <button
        type="button"
        onClick={() => setOpen((was) => !was)}
        className="text-xs text-slate-500 transition hover:text-sky-400"
      >
        {open ? "▾" : "▸"} {words.length} removed word
        {words.length === 1 ? "" : "s"}
      </button>

      {open && (
        <ul className="mt-4 flex flex-wrap gap-2">
          {words.map((item) => (
            <li
              key={item.word}
              className="flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-900/40 px-3 py-1.5"
            >
              <span className="text-xs text-slate-300">{item.word}</span>
              {/* A word retired before it left the bank has no IPA to show. */}
              {item.ipa && <span className="text-xs text-slate-600">/{item.ipa}/</span>}
              <button
                type="button"
                onClick={() => onRestore(item.word)}
                className="text-[11px] text-slate-500 transition hover:text-emerald-400"
              >
                restore
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
